import type { SVGProps } from "react";
export interface PawIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function PawIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: PawIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M2.712 6.545c1.62-.59 3.23.468 3.77 1.952.54 1.485-.013 3.33-1.633 3.92s-3.229-.468-3.769-1.952c-.54-1.485.012-3.33 1.632-3.92m14.807 1.952c.54-1.484 2.149-2.542 3.769-1.952s2.173 2.435 1.633 3.92-2.15 2.542-3.77 1.952-2.173-2.435-1.632-3.92M3.482 8.66c-.195.07-.503.444-.288 1.035s.69.68.886.61c.196-.072.502-.446.287-1.038-.215-.59-.689-.678-.885-.607m17.037 0c-.196-.072-.671.017-.887.607-.215.591.092.966.287 1.038.196.07.671-.018.887-.61.214-.59-.092-.964-.287-1.035M7.442.975c1.805-.483 3.454.822 3.904 2.5.45 1.68-.327 3.634-2.132 4.117-1.804.484-3.453-.82-3.903-2.499s.326-3.634 2.13-4.118Zm5.212 2.5c.45-1.678 2.1-2.983 3.904-2.5s2.582 2.439 2.132 4.118-2.1 2.983-3.905 2.5c-1.804-.485-2.58-2.438-2.131-4.117Zm-4.63-.326c-.328.088-.747.587-.54 1.361.208.775.82.996 1.149.908.328-.088.748-.587.54-1.36-.207-.775-.82-.996-1.148-.909Zm7.952 0c-.328-.088-.94.134-1.148.908-.208.775.212 1.273.54 1.361s.941-.133 1.149-.908c.207-.774-.212-1.272-.54-1.36ZM12 9.875c2.083 0 3.862 1.325 5.075 2.563 1.236 1.262 2.127 2.68 2.42 3.345.683 1.55.833 3.289.331 4.715-.526 1.496-1.786 2.626-3.67 2.627-1.133 0-2.097-.323-2.822-.597-.393-.148-.65-.256-.917-.347-.26-.089-.378-.104-.418-.104s-.156.016-.415.104c-.268.091-.526.199-.919.347-.724.274-1.688.596-2.821.597-1.884 0-3.143-1.13-3.67-2.627-.501-1.426-.352-3.166.331-4.715.293-.664 1.183-2.084 2.419-3.345 1.213-1.238 2.992-2.563 5.075-2.563Zm0 2.25c-1.15 0-2.373.77-3.47 1.888-1.072 1.095-1.797 2.294-1.967 2.678-.5 1.136-.542 2.278-.266 3.061.25.714.738 1.123 1.547 1.123.713 0 1.365-.202 2.026-.452.3-.113.678-.266.988-.372.317-.107.72-.224 1.141-.224s.826.116 1.143.224c.31.106.688.26.987.372.661.25 1.314.452 2.028.452.809 0 1.296-.41 1.547-1.123.275-.783.232-1.925-.268-3.061-.17-.384-.895-1.583-1.968-2.678-1.096-1.118-2.319-1.888-3.469-1.888Z"
      />
    </svg>
  );
}
